import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TextInputComponent } from "@app/kernel/form/modules/inputs/simple-inputs/components/text-input/text-input.component";
import { TranslateModule } from "@ngx-translate/core";
import { EmailFormModel } from "../../models/email-form.model";

@Component({
  selector: "app-update-email-form",
  imports: [ReactiveFormsModule, TranslateModule, CommonModule, TextInputComponent],
  templateUrl: "./update-email-form.component.html",
  styleUrl: "./update-email-form.component.scss",
})
export class UpdateEmailFormComponent {
  readonly formModel = inject(EmailFormModel);
}
